module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "menu bioseco"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "menu-box"
  }, [_c('ul', {
    staticClass: "main-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/",
      "exact": ""
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.home')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "submenu",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/products"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.products.title')))])]), _vm._v(" "), _c('ul', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/products/farms"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.products.farms')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/products/airport"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.products.airports')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/products/area"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.products.ornithologists')))])])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/infonews"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.news')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/certificates"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.certs')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/awards"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.awards')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "submenu disabled",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants",
      "event": ''
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.title')))])]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/bps"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.bps')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/afms"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.afms')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/bridgealfa"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.ba')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/pmt"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.pmt')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/eic"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.eic'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/bps2"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.bps2'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/pbe"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.pbe'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/pbe2"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.pbe2'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/ppbb"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.ppbb'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/offshore"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.offshore'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1)])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/about"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.about')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/contact"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.contact')))])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.ask')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "menu-box"
  }, [_c('ul', {
    staticClass: "lang-menu"
  }, [_c('li', {
    class: {
      'active': _vm.lang === 'en'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setLang('en')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.english')))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.lang === 'pl'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setLang('pl')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.polish')))])])]), _vm._v(" "), _c('a', {
    staticClass: "fb-icon",
    attrs: {
      "href": "https://www.facebook.com/Bioseco-497515667013273/",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "linked-icon",
    attrs: {
      "href": "https://pl.linkedin.com/company/bioseco/",
      "target": "_blank"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c831be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 292
// module chunks = 0